<template>
  <div class="base">
    <div class="row">
      <div class="item">
        <el-form-item
          ref="name"
          :label="schema.name.lbl"
          :rules="rules[`${item.id}__name`]"
          :prop="`${item.id}__name`"
          class="input"
        >
          <Input
            :field="{
              ...schema.name,
              name: `${item.id}__name`
            }"
            :model="item.fields[0].value"
            @set-value="
              (name, val) =>
                handleChange({
                  [schema.name.name]: val
                })
            "
          />
        </el-form-item>
      </div>
      <div class="item">
        <el-form-item
          ref="position"
          :label="schema.position.lbl"
          :rules="rules[`${item.id}__position`]"
          :prop="`${item.id}__position`"
          class="input"
        >
          <Input
            :field="{
              ...schema.position,
              name: `${item.id}__position`
            }"
            :model="item.fields[1].value"
            @set-value="
              (name, val) =>
                handleChange({
                  [schema.position.name]: val
                })
            "
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <el-form-item
          ref="organization"
          :label="schema.organization.lbl"
          :rules="rules[`${item.id}__organization`]"
          :prop="`${item.id}__organization`"
          class="input"
        >
          <Input
            :field="{
              ...schema.organization,
              name: `${item.id}__organization`
            }"
            :model="item.fields[2].value"
            @set-value="
              (name, val) =>
                handleChange({
                  [schema.organization.name]: val
                })
            "
          />
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixins';
import { FormItem } from 'element-ui';
import Input from 'Elements/Input/Input';

export default {
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      rules: {}
    };
  },
  created() {
    this.item.fields.map(item => {
      if (!this.schema[item.name]) return;

      if (this.schema[item.name].required) {
        this.$set(this.rules, `${this.item.id}__${item.name}`, {
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['blur', 'focus', 'change']
        });
      }
    });
  },
  mounted() {
    //очищаем начальную валидацию
    this.clearCustomFormFieldsValidation();
  },
  methods: {
    handleChange(fields = {}) {
      this.$emit('set-value', this.item, this.index, fields);
    }
  },
  components: {
    'el-form-item': FormItem,
    Input
  }
};
</script>
<style lang="scss" scoped>
.base {
  width: 100%;

  .row {
    display: flex;
    margin-bottom: 11px !important;
    width: 100%;
    gap: 24px;

    .item {
      display: flex;
      width: 100%;
      align-items: flex-start;
    }

    .input {
      width: 100%;
      color: $blue-130 !important;
      font-size: 14px;
      line-height: 24px;
    }

    & ::v-deep label {
      display: inline-block;
      white-space: nowrap;
      margin: 0;
    }
  }

  .row:last-child {
    margin-bottom: 0;
  }
}
</style>
